"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateData = {
    "simple.a0l": {
        name: '<br>A0L.T1',
        html: 'simple.l.html',
        css: 'simple.l.css',
        paperSize: [1189, 841 - 3],
        mapSize: [1056, 831]
    },
    "simple.a0p": {
        name: 'A0P.T1',
        html: 'simple.html',
        css: 'simple.css',
        paperSize: [841, 1189 - 2],
        mapSize: [831, 1056]
    },
    "simple.a1l": {
        name: 'A1L.T1',
        html: 'simple.l.html',
        css: 'simple.l.css',
        paperSize: [841, 594 - 3],
        mapSize: [708, 584]
    },
    "simple.a1p": {
        name: 'A1P.T1',
        html: 'simple.html',
        css: 'simple.css',
        paperSize: [594, 841 - 4],
        mapSize: [584, 708]
    },
    "simple.a2l": {
        name: 'A2L.T1',
        html: 'simple.l.html',
        css: 'simple.l.css',
        paperSize: [594, 420 - 3],
        mapSize: [461, 410]
    },
    "simple.a3l": {
        name: 'A3L.T1',
        html: 'simple.l.html',
        css: 'simple.l.css',
        paperSize: [420, 297 - 3],
        mapSize: [287, 287]
    },
    "simple.a4": {
        name: 'A4P.T1',
        html: 'simple.html',
        css: 'simple.css',
        paperSize: [210, 297],
        mapSize: [200, 200]
    },
    "raw.a4": {
        name: '<br><br>A4P.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [210, 297],
        mapSize: [210, 297]
    },
    "raw.a4l": {
        name: 'A4L.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [297, 210],
        mapSize: [297, 210]
    },
    "raw.a3": {
        name: 'A3P.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [297, 420],
        mapSize: [297, 420]
    },
    "raw.a3l": {
        name: 'A3L.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [420, 297],
        mapSize: [420, 297]
    },
    "raw.a2": {
        name: 'A2P.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [420, 594],
        mapSize: [420, 594]
    },
    "raw.a2l": {
        name: 'A2L.T0',
        html: 'raw.html',
        css: 'raw.css',
        paperSize: [594, 420],
        mapSize: [594, 420]
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/templates.ts
// module id = 8
// module chunks = 0